var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.246 6.505H8.268c-1.113 0-2.02.898-2.02 2.001v6.915c0 1.104.907 2.002 2.02 2.002h6.978c1.114 0 2.02-.898 2.02-2.002V8.506a2.013 2.013 0 0 0-2.02-2.001Zm-3.489 9.053c-2 0-3.626-1.612-3.626-3.594 0-1.982 1.627-3.594 3.626-3.594 2 0 3.627 1.612 3.627 3.594 0 1.982-1.627 3.594-3.627 3.594Zm2.885-7.296c0 .47.385.85.859.85a.855.855 0 0 0 .858-.85.855.855 0 0 0-.858-.85.855.855 0 0 0-.859.85Z",
    fill: "url(#instagram_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.757 9.889a2.088 2.088 0 0 0-2.094 2.075c0 1.144.94 2.076 2.094 2.076a2.087 2.087 0 0 0 2.095-2.076c0-1.144-.94-2.075-2.095-2.075Z",
    fill: "url(#instagram_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.052 11.933C.052 5.526 5.292.332 11.757.332s11.706 5.194 11.706 11.6c0 6.407-5.241 11.601-11.706 11.601-6.464 0-11.705-5.194-11.705-11.6Zm15.194 7.01c1.96 0 3.553-1.58 3.553-3.521V8.507c0-1.942-1.594-3.521-3.553-3.521H8.27c-1.96 0-3.553 1.58-3.553 3.52v6.916c0 1.941 1.594 3.52 3.553 3.52h6.977Z",
    fill: "url(#instagram_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__a",
    x1: 11.757,
    y1: 6.505,
    x2: 11.757,
    y2: 17.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0822E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__b",
    x1: 11.757,
    y1: 9.889,
    x2: 11.757,
    y2: 14.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0822E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__c",
    x1: 11.757,
    y1: 0.332,
    x2: 11.757,
    y2: 23.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0822E"
  })))));
};
export default SvgInstagram;